import { useRef } from 'react';

import { E_DEVICE_TYPE } from '@common/configs';
import CreativeFrame from '@components/CreativeFrame';

import { useGroupedFramesScale } from './hooks';
import type { IGroupedSlideProps, ISingleSlideProps } from './types';

import style from './styles.module.scss';

export const SingleSlide = ({ deviceType, imageSrc, campaignName, startDate, endDate }: ISingleSlideProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div className={style['slide-item']}>
      <div
        className={style['frame-container']}
        ref={containerRef}
      >
        <CreativeFrame
          deviceType={deviceType}
          imageSrc={imageSrc}
          containerRef={containerRef}
        />
      </div>
      <div className={style.detail}>
        <span className={style.campaign}>{campaignName}</span>
        <span className={style.date}>
          {startDate} &ndash; {endDate}
        </span>
      </div>
    </div>
  );
};

export const GroupedSlide = ({
  desktopImageSrc,
  mobileImageSrc,
  campaignName,
  startDate,
  endDate,
}: IGroupedSlideProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const groupedScale = useGroupedFramesScale(containerRef);

  return (
    <div className={style['slide-item']}>
      <div
        className={style['grouped-frame-container']}
        ref={containerRef}
      >
        <div className={style['grouped-frames']}>
          <CreativeFrame
            deviceType={E_DEVICE_TYPE.DESKTOP}
            imageSrc={desktopImageSrc}
            containerRef={containerRef}
            className={style['grouped-frame']}
            sharedScale={groupedScale}
          />
          <CreativeFrame
            deviceType={E_DEVICE_TYPE.MOBILE}
            imageSrc={mobileImageSrc}
            containerRef={containerRef}
            className={style['grouped-frame']}
            sharedScale={groupedScale}
          />
        </div>
      </div>
      <div className={style.detail}>
        <span className={style.campaign}>{campaignName}</span>
        <span className={style.date}>
          {startDate} &ndash; {endDate}
        </span>
      </div>
    </div>
  );
};
